/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatAutomatonRequestElementSettingHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_SETTING);
	this.REPLACE_STRING = "_REPLACE_";
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler'] = com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ChatAutomatonRequestElementSettingHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * setAttribute - Replace or remove attribute for given element
 *
 * $type TFun([{ name => elementID, t => TInst(String,[]), opt => false },{ name => attributeName, t => TInst(String,[]), opt => false },{ name => attributeValue, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @static
 * @param {string}  elementID 
 * @param {string}  attributeName 
 * @param {string}  attributeValue 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.setAttribute = function(elementID,attributeName,attributeValue) {
	/** @type {NodeList} */
	var elements = window.document.getElementsByName(elementID);
	if(elements.length == 0) haxe.Log.trace("element not found by name [" + elementID + "]",{ fileName : "ChatAutomatonRequestElementSettingHandler.hx", lineNumber : 72, className : "com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler", methodName : "setAttribute", customParams : ["error"]}); else {
		var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = elements.length;
		while(_g1 < _g) {
			var /** @type {number} */ ix = _g1++;
			var /** @type {js.HtmlDom} */ el = elements[ix];/* Get last element by this name */
			if(el.name != elementID) continue;
			if(attributeName == "disabled" && el.tagName == "A") {
				/*
				 * if the disabled is bold then dark gray and bold
				 * else the style is gray colored.
				 */
				el.setAttribute("STYLE",attributeValue == "bold"?"color: #323232; font-weight: bold":"color: gray");
				try {
					el.removeAttribute("onclick");
				} catch( e ) {
				}
				el.setAttribute("onclick","return false;");
				try {
					el.removeAttribute("HREF");
				} catch( e ) {
				}
				try {
					el.removeAttribute("href");
				} catch( e ) {
				}
			} else if(attributeValue == "null") try {
				el.removeAttribute(attributeName);
			} catch( e ) {
			} else el.setAttribute(attributeName,attributeValue);
			
			com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.setAttributesInChatTextArea(el);
		}
	}
};


/**
 * incrementOutstandingCount - increments counter when TYPE_CHAT_AUTOMATON_SETTING message is sent
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function incrementOutstandingCount():Void
 * @public
 * @static
 * @see ApplicationController class method sendInputState
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.incrementOutstandingCount = function() {
	com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding++;
	haxe.Log.trace("incrementOutstandingCount: " + com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding,{ fileName : "ChatAutomatonRequestElementSettingHandler.hx", lineNumber : 109, className : "com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler", methodName : "incrementOutstandingCount"});
};


/**
 * decrementOutstandingCount - decrements counter when TYPE_CHAT_AUTOMATON_SETTING message is sent
 * This private method is called when the message is responded to (and not a replay).
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function decrementOutstandingCount():Void
 * @private
 * @static
 * @see ChatAutomatonRequestElementSettingHandler method processMessage
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.decrementOutstandingCount = function() {
	--com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding;
	haxe.Log.trace("decrementOutstandingCount: " + com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding,{ fileName : "ChatAutomatonRequestElementSettingHandler.hx", lineNumber : 122, className : "com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler", methodName : "decrementOutstandingCount"});
	if(com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding < 0) com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding = 0;
};


/**
 * getOutstandingCount - returns counter of outstanding messages
 *
 * $type TFun([],TInst(Int,[]))
 * public static function getOutstandingCount():Int
 * @public
 * @static
 * @see SkinControl method PushToFrameset
 * @return {number} - count
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.getOutstandingCount = function() {
	return com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding;
};


/**
 * hasNoOutstandingMessages
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function hasNoOutstandingMessages():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.hasNoOutstandingMessages = function() {
	return com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.getOutstandingCount() == 0;
};


/**
 * setAttributesInChatTextArea - find the modified HTML in the text area and replace it with new HTML
 * 1. Find the automaton id
 * 2. Find this item in the Chat Text Area
 * 3. Replace HTML in ChatTextArea with the modified automaton from the element
 *
 * $type TFun([{ name => element, t => TType(js.HtmlDom,[]), opt => false }],TEnum(Void,[]))
 * private static function setAttributesInChatTextArea(element:HtmlDom):Void
 * @private
 * @static
 * @param {Node}  element -  that has been modified
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.setAttributesInChatTextArea = function(element) {
	com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.setEngaged();
	/** @type {com.inq.flash.client.chatskins.ChatTextArea} */
	var cw = com.inq.flash.client.chatskins.SkinControl.getChatWindow();
	cw.updateTranscriptArray(element);
};


/**
 * setEngaged
 * If not yet engaged, set engaged state
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function setEngaged():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.setEngaged = function() {
	if(com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler._engaged) return;
	com.inq.flash.client.control.Incrementality.onEngaged();
	com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler._engaged = true;
};


/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.prototype.processMessage = function(message) {
	com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler._engaged = true;
	if("1" != message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY)) {
		com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.decrementOutstandingCount();
		return;
	}
	/** @type {string} */ 
	var elementID = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_ID);
	/** @type {string} */ 
	var attributeName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_TYPE);
	/** @type {string} */ 
	var attributeValue = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_STATE);
	/* trace("chat.setting received: " + elementID + ": " + attributeName + " = " + attributeValue); */
	
	/* When replaying chat.setting messages, we must update links' attributes only after they are created.
	 * ​Chat​Automaton​Request​Message​Handler calls SkinControl.​Add​Transcript​ItemToChat​​Window(),
	 * which it turn uses a timer to defer element creation, thus the problem arises.
	 */
	com.inq.flash.client.chatskins.SkinControl.executeAfter(function() {
		return window.document.getElementsByName(elementID).length > 0;
	},function() {
		com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.setAttribute(elementID,attributeName,attributeValue);
	},"ChatAutomatonRequestElementSettingHandler.setAttribute");
};

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.prototype.REPLACE_STRING = null;
/** @private @type {com.inq.flash.client.data.Chat} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.prototype.chat = null;
/** @type {com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler;
/** @private @type {number} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.outstanding = 0;

/** @private @type {boolean} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler._engaged = false;

